import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
 
    children: [
      {
        path: '/',
        meta: {
          title: '首页',
        },
        name: 'Home',
        component: () => import('@/views/home/Index.vue'),
      }]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/Preview',
    name: 'Preview',
    component: () => import('../views/Preview.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
console.log(to.name,!token && to.name !== 'Login' )
  if (!token && to.name !== 'Login') {
    // 如果没有 token 并且目标路由不是登录页，则跳转到登录页
    next({ name: 'Login' });
  }else {
    console.log('next')
    // 允许进入目标路由
    next();
  }
});
export default router
